import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const CalendarEditLeavePage = React.lazy(
  () => import('modules/timeoff/pages/calendar/CalendarEditLeavePage')
)
const CalendarRejectLeavePage = React.lazy(
  () => import('modules/timeoff/pages/calendar/CalendarRejectLeavePage')
)

const RootPage = React.lazy(() => import('modules/timeoff/pages/calendar/RootPage'))

const calendarRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.calendar.leaves.path,
      element: <RootPage />,
      children: [
        {
          path: navigation.calendar.leaves.editLeave.path,
          element: <CalendarEditLeavePage />,
        },
        {
          path: navigation.calendar.leaves.rejectLeave.path,
          element: <CalendarRejectLeavePage />,
        },
      ],
    },
  ]
}

export default calendarRoutes
